import { ColumnDef } from '@tanstack/react-table';
import {
  formatTableDate,
  formatTableTimestamp,
} from '../../utils/formatTableDate';
import {
  SortableHeader,
  TruncatedCell,
  DownloadedCheckmark,
} from '@/components';
import { PathologyResultRecord } from '../types';
import { PatientDocumentViewButton } from '../../components';
import { DocumentSource, DocumentType } from '../../viewer';

export const createPathologyResultsColumns =
  (): ColumnDef<PathologyResultRecord>[] => [
    {
      accessorKey: 'name',
      header: 'Title',
      cell: ({ row }) =>
        row.original.name ? (
          <TruncatedCell text={row.original.name} />
        ) : (
          'No data available'
        ),
    },
    {
      id: 'dateOfStudy',
      accessorKey: 'dateOfStudy',
      enableSorting: true,
      header: ({ column }) => (
        <SortableHeader column={column}>Date</SortableHeader>
      ),
      cell: ({ row }) => formatTableDate(row.original.dateOfStudy),
    },
    {
      id: 'dateUploaded',
      accessorFn: (row) => row.createdAt,
      enableSorting: true,
      header: ({ column }) => (
        <SortableHeader column={column}>Date Uploaded</SortableHeader>
      ),
      cell: ({ row }) => formatTableTimestamp(row.original.createdAt),
    },
    {
      accessorKey: 'sourceType',
      enableSorting: true,
      header: ({ column }) => (
        <SortableHeader column={column}>Source Type</SortableHeader>
      ),
      cell: ({ row }) => row.original.sourceType || 'No data available',
    },
    {
      id: 'markedDownloaded',
      enableSorting: false,
      header: '',
      cell: ({ row }) =>
        row.original.markedDownloaded ? <DownloadedCheckmark /> : null,
    },
    {
      id: 'actions',
      enableSorting: false,
      header: '',
      cell: ({ row }) => (
        <div className="flex items-center justify-end gap-1">
          <PatientDocumentViewButton
            disabled={!row.original.sourceType}
            documentKey={{
              source: DocumentSource.MEDICAL_RECORDS,
              type: DocumentType.PATHOLOGY_RESULTS,
              pathologyId: row.original.id,
              sourceType: row.original.sourceType,
              name: row.original.name,
            }}
          />
        </div>
      ),
    },
  ];
